export const colors = {
	primary: "#FFFFFF",
	secondary: "#000000",
	semiWhite: "#FFFDFD",
	semiGrey: "#E5E5E5",
	blackGrey: "#1F1F1F",
	greyGrey: "#989898",
};
